(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sender-story-style"] && !Shopify.designMode) return;
  try {
    if (!window.senderStoryReference) {
  window.senderStoryReference = true;
  const rails = new Map();
  const selectedAccordions = new WeakMap();
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const syncAccordion = row => {
    const summary = row.querySelector('summary');
    summary?.setAttribute('aria-expanded', String(row.open));
    row.classList.toggle('is-offen', row.open);
  };
  const updatePackNotes = quantity => {
    const count = Math.max(1, Number(quantity) || 1);
    const format = new Intl.NumberFormat(document.documentElement.lang || 'de', { maximumFractionDigits: 2 });
    document.querySelectorAll('[data-story-pack-note]').forEach(note => {
      const text = note.dataset.storyPackNote;
      const parts = text.match(/^(\d+(?:[.,]\d+)?)\s+([^·]+?)\s*·\s*(\d+(?:[.,]\d+)?)\s+Portionen$/i);
      if (!parts) { note.textContent = text; return; }
      const amount = Number(parts[1].replace(',', '.')) * count;
      const portions = Number(parts[3].replace(',', '.')) * count;
      note.textContent = `${format.format(amount)} ${parts[2]} · ${format.format(portions)} Portionen`;
    });
  };
  document.addEventListener('sender-story:selection', event => updatePackNotes(event.detail.quantity));
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-story-accordion]')) syncAccordion(event.target);
  }, true);
  document.addEventListener('shopify:block:select', event => {
    const row = event.target.closest('[data-story-accordion]');
    if (row) {
      if (!selectedAccordions.has(row)) selectedAccordions.set(row, row.open);
      row.open = true;
      syncAccordion(row);
    }
    const card = event.target.closest('.mm-rail > *');
    const state = card && rails.get(card.parentElement);
    if (state) state.go([...card.parentElement.children].indexOf(card));
  });
  document.addEventListener('shopify:block:deselect', event => {
    const row = event.target.closest('[data-story-accordion]');
    if (row && selectedAccordions.has(row)) {
      row.open = selectedAccordions.get(row);
      selectedAccordions.delete(row);
      syncAccordion(row);
    }
  });
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-story-accordion]').forEach(syncAccordion);
    scope.querySelectorAll('.mm-rail').forEach(rail => {
      if (rails.has(rail)) return;
      const nav = rail.parentElement.querySelector('[data-railnav]');
      const cards = [...rail.children];
      if (!nav || !cards.length) return;
      const controller = new AbortController();
      const options = {signal:controller.signal};
      const points = nav.querySelector('[data-rail-punkte]');
      const prev = nav.querySelector('[data-rail-zurueck]');
      const next = nav.querySelector('[data-rail-vor]');
      points.replaceChildren();
      let active = 0;
      const positions = () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const padding = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
        return cards.map((card, i) => i === 0 ? 0 : i === cards.length - 1 ? max : Math.max(0, Math.min(max, card.offsetLeft - cards[0].offsetLeft - (rail.clientWidth - card.clientWidth) / 2 + padding)));
      };
      const go = index => {
        const target = Math.max(0, Math.min(index, cards.length - 1));
        rail.scrollTo({left: positions()[target], behavior: reducedMotion() ? 'instant' : 'smooth'});
      };
      cards.forEach((card, index) => {
        const dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'mm-railnav__punkt'; dot.setAttribute('aria-label', String(index + 1));
        dot.addEventListener('click', () => go(index), options); points.append(dot);
      });
      const update = () => {
        if (!rail.isConnected) return;
        nav.hidden = rail.scrollWidth <= rail.clientWidth + 2;
        const targets = positions();
        active = targets.reduce((best, value, i) => Math.abs(value - rail.scrollLeft) < Math.abs(targets[best] - rail.scrollLeft) ? i : best, 0);
        [...points.children].forEach((dot, i) => {dot.classList.toggle('is-an', i === active); dot.setAttribute('aria-current', String(i === active));});
        prev.disabled = nav.hidden || rail.scrollLeft <= 1;
        next.disabled = nav.hidden || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      prev.addEventListener('click', () => go(active - 1), options);
      next.addEventListener('click', () => go(active + 1), options);
      rail.addEventListener('scroll', update, {...options, passive:true});
      window.addEventListener('resize', update, options);
      const observer = window.ResizeObserver ? new ResizeObserver(update) : null;
      observer?.observe(rail);
      rails.set(rail, {go, controller, observer});
      update();
    });
    const selected = document.querySelector('sender-story-product[data-mode="main"] [name="quantity"]:checked');
    if (selected) updatePackNotes(selected.value);
  };
  document.addEventListener('shopify:section:unload', event => {
    for (const [rail, state] of rails) {
      if (!event.target.contains(rail)) continue;
      state.controller.abort(); state.observer?.disconnect(); rails.delete(rail);
    }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
}
  } catch(e) { console.error(e); }
})();

})();
